document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      const count = event.cartData?.item_count;
      if (typeof count === 'number') document.querySelectorAll('.bs-cart-count').forEach(el => {
        el.textContent = count;
        el.closest('a')?.setAttribute('aria-label', `Cart, ${count} items`);
      });
    });
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const updated = event.data?.html?.querySelector('.bs-benefits');
      if (!updated) return;
      const current = document.getElementById(updated.id);
      if (current) current.replaceWith(updated.cloneNode(true));
    });
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bs-mobile-menu[open]').forEach(menu => {
      menu.removeAttribute('open'); menu.querySelector('summary').focus();
    });
  });
});
if (!customElements.get('bs-recommendations')) customElements.define('bs-recommendations', class extends HTMLElement {
  connectedCallback() {
    if (this.loaded) return;
    this.loaded = true;
    fetch(this.dataset.url).then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
      .then(text => {
        if (!this.isConnected) return;
        const document = new DOMParser().parseFromString(text, 'text/html');
        const grid = document.querySelector('[data-recommendation-grid]');
        if (grid?.querySelectorAll('.bs-card').length) this.querySelector('[data-recommendation-grid]').replaceWith(grid);
      }).catch(() => { /* Server-rendered catalog cards remain usable without recommendations. */ });
  }
});
